// import React, { useState, useEffect, useRef } from 'react';
// import { Modal, Spinner, Offcanvas, Form } from 'react-bootstrap';
// import axios from 'axios';

// const BankForm = ({ showModal, handleClose, bankId, bankData, addBank, editBank, banks, countries, fetchCountries }) => {
//     const [loading, setLoading] = useState(false); // Track loading state
//     const [allBanks, setAllBanks] = useState([]);
//     const [formData, setFormData] = useState({
//         name: '',
//         branch_name: '',
//         account_holder_name: '',
//         account_number: '',
//         iban: '',
//         swift_code: '',
//         bank_address: '',
//         currency_id: '',
//         exchange_rate: '',
//         opening_balance: '',
//         type: '',

//     });
//     const [errors, setErrors] = useState({});
//     useEffect(() => {
//         if (showModal && countries.length === 0) {
//             fetchCountries();
//         }
//         if (showModal && !bankData) {
//             // Reset formData for new bank creation
//             setFormData({
//                 name: '',
//                 branch_name: '',
//                 account_holder_name: '',
//                 account_number: '',
//                 iban: '',
//                 swift_code: '',
//                 bank_address: '',
//                 currency_id: '',
//                 exchange_rate: '',
//                 opening_balance: '',
//                 type: '',
//             });
//         } else if (bankData) {
//             // Populate formData for editing an bank
//             setFormData({
//                 name: bankData.name || '',
//                 account_number: bankData.account_number || '',
//                 branch_name: bankData.branch_name || '',
//                 account_holder_name: bankData.account_holder_name || '',
//                 iban: bankData.iban || '',
//                 swift_code: bankData.swift_code || '',
//                 bank_address: bankData.bank_address || '',
//                 currency_id: bankData.currency_id || '',
//                 exchange_rate: bankData.exchange_rate || '',
//                 opening_balance: bankData.opening_balance || '',
//                 type: bankData.type || '',
//             });
//         }
//     }, [bankData, showModal]);



//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         // setFormData((prev) => ({ ...prev, [name]: value }));
//         setFormData((prev) => {
//             const newFormData = { ...prev, [name]: value };
//             return newFormData;
//         });
//         if (errors[name]) {
//             setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
//         }
//     };
//     const validateForm = () => {
//         const newErrors = {};
//         if (!formData.name) newErrors.name = '*Name is required';
//         return newErrors;
//     };

//     useEffect(() => {
//         if (!showModal) {
//             setErrors({});
//         }
//     }, [showModal]);



//     const syncBankLedgerWithWebzash = async (bank, oldType = null, oldName = null) => {
//         const API = process.env.REACT_APP_WEBZASH_URL;
//         const backendUrl = `${API}/api`;
//         const headers = {
//             "x-api-key": process.env.REACT_APP_API_KEY,
//             Accept: "application/json",
//             "Content-Type": "application/json",
//         };

//         try {
//             const groupName =
//                 bank.type === "bank account"
//                     ? "Bank Accounts"
//                     : bank.type === "cash account"
//                         ? "Cash-in-Hand"
//                         : null;

//             if (!groupName) throw new Error("Invalid bank type");

//             // Fetch group list
//             const groupListResponse = await axios.get(`${backendUrl}/groups/index`, { headers });
//             let allGroups = Array.isArray(groupListResponse.data?.data)
//                 ? groupListResponse.data.data
//                 : Array.isArray(groupListResponse.data)
//                     ? groupListResponse.data
//                     : [];

//             if (!allGroups.length) throw new Error("Failed to fetch group list");

//             // Get parent group Assets
//             const parent = allGroups.find((g) =>
//                 g.Group?.name?.trim().toLowerCase() === "assets"
//             )?.Group;
//             if (!parent?.id) throw new Error("Assets group not found");

//             // Find or create the specific group (Bank Accounts or Cash-in-Hand)
//             let group = allGroups.find((g) =>
//                 g.Group?.name?.trim().toLowerCase() === groupName.toLowerCase()
//             )?.Group;

//             if (!group) {
//                 await axios.post(`${backendUrl}/groups/add`, {
//                     Group: {
//                         name: groupName,
//                         parent_id: parent.id,
//                         code: null,
//                         affects_gross: 0,
//                     }
//                 }, { headers });

//                 const refreshed = await axios.get(`${backendUrl}/groups/index`, { headers });
//                 allGroups = refreshed.data?.data || [];
//                 group = allGroups.find((g) =>
//                     g.Group?.name?.trim().toLowerCase() === groupName.toLowerCase()
//                 )?.Group;
//             }

//             if (!group?.id) throw new Error("Group creation failed");
//             console.log("Raw opening_balance:", bank.opening_balance);
//             console.log("Raw exchange_rate:", bank.exchange_rate);
//             console.log("Currency object:", bank.currency);
//             console.log("Currency code:", bank?.currency?.currency);


//             let convertedBalance = parseFloat(bank.opening_balance || 0);

//             // fallback to AED if anything missing
//             const exchangeRate = parseFloat(bank.exchange_rate || 1);
//             const bankCurrency = bank?.currency?.currency || bank?.currency || "AED"; // covers both string and object

//             console.log("Resolved currency:", bankCurrency);

//             if (bankCurrency !== "AED" && exchangeRate > 0) {
//                 convertedBalance = convertedBalance * exchangeRate;
//                 console.log("Converted Balance after applying exchange rate:", convertedBalance);
//             }


//             // Fetch ledgers
//             const ledgerRes = await axios.get(`${backendUrl}/ledgers/index`, { headers });
//             const allLedgers = ledgerRes.data?.data || [];

//             // Find by current name or old name
//             const existingLedger = allLedgers.find(
//                 (l) =>
//                     l.Ledger?.name?.trim().toLowerCase() === bank.name.trim().toLowerCase() ||
//                     (oldName && l.Ledger?.name?.trim().toLowerCase() === oldName.trim().toLowerCase())
//             );

//             if (existingLedger) {
//                 const currentGroupId = existingLedger.Ledger?.group_id;
//                 const needsGroupUpdate = oldType && oldType !== bank.type && currentGroupId !== group.id;
//                 const needsNameUpdate = existingLedger.Ledger.name?.trim() !== bank.name.trim();

//                 if (needsGroupUpdate || needsNameUpdate) {
//                     await axios.post(`${backendUrl}/ledgers/edit/${existingLedger.Ledger.id}`, {
//                         Ledger: {
//                             ...existingLedger.Ledger,
//                             name: bank.name,
//                             group_id: group.id,
//                             op_balance: convertedBalance,
//                             op_balance_dc: "D",
//                             notes: bank.branch_name || "",
//                             type: 1,
//                             reconciliation: 0,
//                         }
//                     }, { headers });
//                 }
//             } else {
//                 // Create ledger if not exists
//                 await axios.post(`${backendUrl}/ledgers/add`, {
//                     Ledger: {
//                         name: bank.name,
//                         code: null,
//                         group_id: group.id,
//                         op_balance: convertedBalance,
//                         op_balance_dc: "D",
//                         notes: bank.branch_name || "",
//                         type: 1,
//                         reconciliation: 0,
//                     }
//                 }, { headers });
//             }

//         } catch (err) {
//             console.error("Ledger sync failed:", err.message);
//             throw new Error("Ledger sync failed: " + err.message);
//         }
//     };


//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);
//         const validationErrors = validateForm();

//         if (Object.keys(validationErrors).length > 0) {
//             setErrors(validationErrors);
//             setLoading(false);
//             return;
//         }
//         try {
//             if (bankData) {
//                 await syncBankLedgerWithWebzash({ ...formData, currency: bankData.currency }, bankData.type, bankData?.name); // edit mode
//             } else {
//                 await syncBankLedgerWithWebzash(formData); // create mode
//             }
//             let apiErrors;
//             if (bankData) {
//                 apiErrors = await editBank(bankData.id, formData);
//             } else {
//                 apiErrors = await addBank(formData);
//             }

//             if (apiErrors && Object.keys(apiErrors).length > 0) {
//                 setErrors(apiErrors);
//             } else {
//                 setErrors({});
//                 handleClose();
//             }
//         } catch (error) {
//             console.error("An error occurred:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (

//         <Offcanvas show={showModal} onHide={handleClose} placement="end" style={{ width: '440px' }}>
//             <Offcanvas.Header closeButton>
//                 <Offcanvas.Title>{bankId ? 'Edit Account' : 'Add Account'}</Offcanvas.Title>
//             </Offcanvas.Header>
//             <hr style={{ margin: 0 }} /><br />

//             <Offcanvas.Body>
//                 <Form>

//                     <Form.Group controlId="date" className="mb-3">
//                         <Form.Label className='form-font'>Account Type</Form.Label>
//                         <Form.Select name='type' value={formData.type} onChange={handleChange} className='form-feild'>
//                             <option value="">Select</option>
//                             <option value="bank account">Bank Account</option>
//                             <option value="cash account">Cash Account</option>
//                         </Form.Select>
//                     </Form.Group>
//                     <Form.Group controlId="name" className="mb-3">
//                         <Form.Label className='form-font'>Name</Form.Label>
//                         <Form.Control
//                             className={`form-feild form-control ${errors.name ? 'is-invalid' : ''}`}
//                             type="text"
//                             name="name"
//                             value={formData.name}
//                             onChange={handleChange}
//                         />
//                         {errors.name && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.name}</div>}

//                     </Form.Group>
//                     {formData.type === 'bank account' && (
//                         <>
//                             <Form.Group controlId="branch_name" className="mb-3">
//                                 <Form.Label className='form-font'>Branch Name</Form.Label>
//                                 <Form.Control
//                                     className='form-control form-feild'
//                                     type="text"
//                                     name="branch_name"
//                                     value={formData.branch_name}
//                                     onChange={handleChange}
//                                 />
//                             </Form.Group>


//                             <Form.Group controlId="account_holder_name" className="mb-3">
//                                 <Form.Label className='form-font'>Account Holder Name</Form.Label>
//                                 <Form.Control
//                                     className='form-control form-feild'
//                                     type="text"
//                                     name="account_holder_name"
//                                     value={formData.account_holder_name}
//                                     onChange={handleChange}
//                                 />
//                             </Form.Group>

//                             <Form.Group controlId="Account Number" className="mb-3">
//                                 <Form.Label className='form-font'>Account Number</Form.Label>
//                                 <Form.Control
//                                     className='form-control form-feild'
//                                     type="text"
//                                     name="account_number"
//                                     value={formData.account_number}
//                                     onChange={handleChange}
//                                 />
//                             </Form.Group>

//                             <Form.Group controlId="iban" className="mb-3">
//                                 <Form.Label className='form-font'>IBAN(International Bank Account Number)</Form.Label>
//                                 <Form.Control
//                                     className='form-control form-feild'
//                                     type="text"
//                                     name="iban"
//                                     value={formData.iban}
//                                     onChange={handleChange}
//                                 />
//                             </Form.Group>

//                             <Form.Group className="mb-3" >
//                                 <Form.Label className='form-font'>SWIFT/BIC Code</Form.Label>
//                                 <Form.Control
//                                     className='form-control form-feild'
//                                     type="text"
//                                     name="swift_code"
//                                     value={formData.swift_code}
//                                     onChange={handleChange}
//                                 />
//                             </Form.Group>
//                             <Form.Group className="mb-3" >
//                                 <Form.Label className='form-font'>Bank Address</Form.Label>
//                                 <Form.Control
//                                     className='form-control form-feild'
//                                     type="text"
//                                     name="bank_address"
//                                     value={formData.bank_address}
//                                     onChange={handleChange}
//                                 />
//                             </Form.Group>
//                         </>
//                     )}
//                     <Form.Group className="mb-3" >
//                         <Form.Label className='form-font'>Opening Balance</Form.Label>
//                         <Form.Control
//                             className='form-control form-feild'
//                             type="text"
//                             name="opening_balance"
//                             value={formData.opening_balance}
//                             onChange={handleChange}
//                         />
//                     </Form.Group>

//                     {/* <Form.Group controlId="currency_id" className="mb-3">
//                         <Form.Label className='form-font'>Currency</Form.Label>
//                         <Form.Select
//                             className='form-feild'
//                             name="currency_id"
//                             value={formData.currency_id}
//                             onChange={handleChange}
//                         >
//                             <option value="">Select</option>
//                             <option value="229">AED</option>
//                             <option value="231">USD</option>
//                             {countries?.map(country => (
//                                 <option key={country.id} value={country.id}>
//                                     {country.currency}
//                                 </option>
//                             ))}
//                         </Form.Select>
//                     </Form.Group> */}
//                     <Form.Group controlId="currency_id" className="mb-3">
//                         <Form.Label className='form-font'>Currency</Form.Label>
//                         <Form.Select
//                             className='form-feild'
//                             name="currency_id"
//                             value={formData.currency_id}
//                             onChange={handleChange}
//                         >
//                             <option value="">Select</option>

//                             {/* Show AED from UAE and USD from US at the top */}
//                             {countries
//                                 ?.filter(country =>
//                                     (country.currency === 'AED' && country.name === 'United Arab Emirates') ||
//                                     (country.currency === 'USD' && country.name === 'United States')
//                                 )
//                                 .sort((a, b) => {
//                                     const order = ['AED', 'USD'];
//                                     return order.indexOf(a.currency) - order.indexOf(b.currency);
//                                 })
//                                 .map(country => (
//                                     <option key={country.id} value={country.id}>
//                                         {country.currency}
//                                     </option>
//                                 ))}

//                             {/* Show all other currencies, excluding UAE/AED and US/USD */}
//                             {countries
//                                 ?.filter(country =>
//                                     !(
//                                         (country.currency === 'AED' && country.name === 'United Arab Emirates') ||
//                                         (country.currency === 'USD' && country.name === 'United States')
//                                     )
//                                 )
//                                 .map(country => (
//                                     <option key={country.id} value={country.id}>
//                                         {country.currency}
//                                     </option>
//                                 ))}
//                         </Form.Select>
//                     </Form.Group>


//                     <Form.Group className="mb-3" >
//                         <Form.Label className='form-font'>Exchange Rate</Form.Label>
//                         <Form.Control
//                             className='form-control form-feild'
//                             type="text"
//                             name="exchange_rate"
//                             value={formData.exchange_rate}
//                             onChange={handleChange}
//                         />
//                     </Form.Group>


//                 </Form>
//             </Offcanvas.Body>

//             {/* Manually added footer */}
//             <div className="p-3 border-top  d-flex justify-content-end">
//                 <button type="button" className="btn btn-secondary me-2" onClick={handleClose}>
//                     Close
//                 </button>
//                 <button type="button" className="btn btn-primary" onClick={handleSubmit} disabled={loading}>
//                     {loading ? (
//                         <>
//                             <Spinner animation="border" size="sm" className="me-2" />
//                             Saving...
//                         </>
//                     ) : (
//                         'Save'
//                     )}
//                 </button>
//             </div>
//         </Offcanvas>
//     );
// };

// export default BankForm;


// import React, { useState, useEffect } from 'react';
// import { Spinner, Offcanvas, Form, Button, Row, Col } from 'react-bootstrap';
// import axios from 'axios';
// import { FaPlus, FaTrash } from 'react-icons/fa';

// const BankForm = ({ showModal, handleClose, bankId, bankData, addBank, editBank, banks, countries, fetchCountries }) => {
//     const [loading, setLoading] = useState(false);
//     const [formData, setFormData] = useState({
//         name: '',
//         branch_name: '',
//         account_holder_name: '',
//         account_number: '',
//         iban: '',
//         swift_code: '',
//         bank_address: '',
//         base_currency_id: '',
//         opening_balance: '',
//         type: '',
//         exchange_rates: []
//     });

//     const [errors, setErrors] = useState({});

//     // Initialize or reset form data
//     useEffect(() => {
//         if (showModal && countries.length === 0) {
//             fetchCountries();
//         }

//         if (showModal && !bankData) {
//             // Reset formData for new bank creation
//             setFormData({
//                 name: '',
//                 branch_name: '',
//                 account_holder_name: '',
//                 account_number: '',
//                 iban: '',
//                 swift_code: '',
//                 bank_address: '',
//                 base_currency_id: '',
//                 opening_balance: '',
//                 type: '',
//                 exchange_rates: []
//             });
//         } else if (bankData) {
//             // Populate formData for editing a bank
//             // Make sure exchange_rates is always an array
//             const exchangeRates = Array.isArray(bankData.exchange_rates) ? bankData.exchange_rates : [];

//             setFormData({
//                 name: bankData.name || '',
//                 account_number: bankData.account_number || '',
//                 branch_name: bankData.branch_name || '',
//                 account_holder_name: bankData.account_holder_name || '',
//                 iban: bankData.iban || '',
//                 swift_code: bankData.swift_code || '',
//                 bank_address: bankData.bank_address || '',
//                 base_currency_id: bankData.base_currency_id || bankData.currency_id || '',
//                 opening_balance: bankData.opening_balance || '',
//                 type: bankData.type || '',
//                 exchange_rates: exchangeRates
//             });
//         }
//     }, [bankData, showModal]);

//     // Handle form field changes
//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prev) => ({ ...prev, [name]: value }));

//         if (errors[name]) {
//             setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
//         }
//     };

//     // Handle exchange rate field changes
//     const handleExchangeRateChange = (index, field, value) => {
//         setFormData(prev => {
//             const updatedRates = [...prev.exchange_rates];
//             updatedRates[index] = {
//                 ...updatedRates[index],
//                 [field]: value
//             };
//             return { ...prev, exchange_rates: updatedRates };
//         });
//     };

//     // Add new exchange rate row
//     const addExchangeRate = () => {
//         if (!formData.base_currency_id) {
//             alert('Please select base currency first');
//             return;
//         }

//         setFormData(prev => ({
//             ...prev,
//             exchange_rates: [
//                 ...prev.exchange_rates,
//                 {
//                     currency_id: '',
//                     rate: ''
//                 }
//             ]
//         }));
//     };

//     // Remove exchange rate row
//     const removeExchangeRate = (index) => {
//         setFormData(prev => ({
//             ...prev,
//             exchange_rates: prev.exchange_rates.filter((_, i) => i !== index)
//         }));
//     };

//     // Get available currencies for exchange rates (excluding base currency and already selected currencies)
//     const getAvailableCurrencies = () => {
//         if (!formData.base_currency_id) {
//             return []; // Return empty if no base currency selected
//         }

//         // Filter out empty/null IDs
//         const selectedCurrencyIds = formData.exchange_rates
//             .map(rate => rate.currency_id)
//             .filter(id => id && id !== '' && id != null);

//         return countries.filter(country => {
//             // Skip if no country ID
//             if (!country || !country.id) return false;

//             // Skip if it's the base currency
//             if (country.id == formData.base_currency_id) return false;

//             // Skip if already selected
//             if (selectedCurrencyIds.includes(country.id)) return false;

//             return true;
//         });
//     };
//     // Get currency name by ID
//     const getCurrencyName = (currencyId) => {
//         const country = countries.find(c => c.id == currencyId);
//         return country ? country.currency : '';
//     };

//     // Validate form
//     const validateForm = () => {
//         const newErrors = {};

//         // Required fields
//         if (!formData.name) newErrors.name = '*Name is required';
//         if (!formData.type) newErrors.type = '*Account type is required';
//         if (!formData.base_currency_id) newErrors.base_currency_id = '*Base currency is required';

//         // Validate exchange rates
//         formData.exchange_rates.forEach((rate, index) => {
//             if (!rate.currency_id) {
//                 newErrors[`exchange_rate_currency_${index}`] = '*Currency is required';
//             }
//             if (!rate.rate || isNaN(parseFloat(rate.rate)) || parseFloat(rate.rate) <= 0) {
//                 newErrors[`exchange_rate_rate_${index}`] = '*Valid exchange rate is required';
//             }

//             // Check for duplicate currencies
//             const duplicateIndex = formData.exchange_rates.findIndex((r, i) =>
//                 i !== index && r.currency_id === rate.currency_id
//             );
//             if (duplicateIndex !== -1) {
//                 newErrors[`exchange_rate_currency_${index}`] = '*Currency already selected';
//             }
//         });

//         return newErrors;
//     };

//     const syncBankLedgerWithWebzash = async (bank, oldType = null, oldName = null) => {
//         const API = process.env.REACT_APP_WEBZASH_URL;
//         const backendUrl = `${API}/api`;
//         const headers = {
//             "x-api-key": process.env.REACT_APP_API_KEY,
//             Accept: "application/json",
//             "Content-Type": "application/json",
//         };

//         try {
//             const groupName =
//                 bank.type === "bank account"
//                     ? "Bank Accounts"
//                     : bank.type === "cash account"
//                         ? "Cash-in-Hand"
//                         : null;

//             if (!groupName) throw new Error("Invalid bank type");

//             // Fetch group list
//             const groupListResponse = await axios.get(`${backendUrl}/groups/index`, { headers });
//             let allGroups = Array.isArray(groupListResponse.data?.data)
//                 ? groupListResponse.data.data
//                 : Array.isArray(groupListResponse.data)
//                     ? groupListResponse.data
//                     : [];

//             if (!allGroups.length) throw new Error("Failed to fetch group list");

//             // Get parent group Assets
//             const parent = allGroups.find((g) =>
//                 g.Group?.name?.trim().toLowerCase() === "assets"
//             )?.Group;
//             if (!parent?.id) throw new Error("Assets group not found");

//             // Find or create the specific group (Bank Accounts or Cash-in-Hand)
//             let group = allGroups.find((g) =>
//                 g.Group?.name?.trim().toLowerCase() === groupName.toLowerCase()
//             )?.Group;

//             if (!group) {
//                 await axios.post(`${backendUrl}/groups/add`, {
//                     Group: {
//                         name: groupName,
//                         parent_id: parent.id,
//                         code: null,
//                         affects_gross: 0,
//                     }
//                 }, { headers });

//                 const refreshed = await axios.get(`${backendUrl}/groups/index`, { headers });
//                 allGroups = refreshed.data?.data || [];
//                 group = allGroups.find((g) =>
//                     g.Group?.name?.trim().toLowerCase() === groupName.toLowerCase()
//                 )?.Group;
//             }

//             if (!group?.id) throw new Error("Group creation failed");
//             console.log("Raw opening_balance:", bank.opening_balance);
//             console.log("Raw exchange_rate:", bank.exchange_rate);
//             console.log("Currency object:", bank.currency);
//             console.log("Currency code:", bank?.currency?.currency);


//             let convertedBalance = parseFloat(bank.opening_balance || 0);

//             // fallback to AED if anything missing
//             const exchangeRate = parseFloat(bank.exchange_rate || 1);
//             const bankCurrency = bank?.currency?.currency || bank?.currency || "AED"; // covers both string and object

//             console.log("Resolved currency:", bankCurrency);

//             if (bankCurrency !== "AED" && exchangeRate > 0) {
//                 convertedBalance = convertedBalance * exchangeRate;
//                 console.log("Converted Balance after applying exchange rate:", convertedBalance);
//             }


//             // Fetch ledgers
//             const ledgerRes = await axios.get(`${backendUrl}/ledgers/index`, { headers });
//             const allLedgers = ledgerRes.data?.data || [];

//             // Find by current name or old name
//             const existingLedger = allLedgers.find(
//                 (l) =>
//                     l.Ledger?.name?.trim().toLowerCase() === bank.name.trim().toLowerCase() ||
//                     (oldName && l.Ledger?.name?.trim().toLowerCase() === oldName.trim().toLowerCase())
//             );

//             if (existingLedger) {
//                 const currentGroupId = existingLedger.Ledger?.group_id;
//                 const needsGroupUpdate = oldType && oldType !== bank.type && currentGroupId !== group.id;
//                 const needsNameUpdate = existingLedger.Ledger.name?.trim() !== bank.name.trim();

//                 if (needsGroupUpdate || needsNameUpdate) {
//                     await axios.post(`${backendUrl}/ledgers/edit/${existingLedger.Ledger.id}`, {
//                         Ledger: {
//                             ...existingLedger.Ledger,
//                             name: bank.name,
//                             group_id: group.id,
//                             op_balance: convertedBalance,
//                             op_balance_dc: "D",
//                             notes: bank.branch_name || "",
//                             type: 1,
//                             reconciliation: 0,
//                         }
//                     }, { headers });
//                 }
//             } else {
//                 // Create ledger if not exists
//                 await axios.post(`${backendUrl}/ledgers/add`, {
//                     Ledger: {
//                         name: bank.name,
//                         code: null,
//                         group_id: group.id,
//                         op_balance: convertedBalance,
//                         op_balance_dc: "D",
//                         notes: bank.branch_name || "",
//                         type: 1,
//                         reconciliation: 0,
//                     }
//                 }, { headers });
//             }

//         } catch (err) {
//             console.error("Ledger sync failed:", err.message);
//             throw new Error("Ledger sync failed: " + err.message);
//         }
//     };

//     // Handle form submission
//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);
//         const validationErrors = validateForm();

//         if (Object.keys(validationErrors).length > 0) {
//             setErrors(validationErrors);
//             setLoading(false);
//             return;
//         }

//         try {
//             // Prepare data for API
//             const apiData = {
//                 ...formData,
//                 // Include currency_id for backward compatibility
//                 currency_id: formData.base_currency_id
//             };
//             if (bankData) {
//                 await syncBankLedgerWithWebzash({ ...formData, currency: bankData.currency }, bankData.type, bankData?.name); // edit mode
//             } else {
//                 await syncBankLedgerWithWebzash(formData);
//             }

//             let apiErrors;
//             if (bankData) {
//                 apiErrors = await editBank(bankData.id, apiData);
//             } else {
//                 apiErrors = await addBank(apiData);
//             }

//             if (apiErrors && Object.keys(apiErrors).length > 0) {
//                 setErrors(apiErrors);
//             } else {
//                 setErrors({});
//                 handleClose();
//             }
//         } catch (error) {
//             console.error("An error occurred:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <Offcanvas show={showModal} onHide={handleClose} placement="end" style={{ width: '580px' }}>
//             <Offcanvas.Header closeButton>
//                 <Offcanvas.Title>{bankId ? 'Edit Account' : 'Add Account'}</Offcanvas.Title>
//             </Offcanvas.Header>
//             <hr style={{ margin: 0 }} /><br />

//             <Offcanvas.Body>
//                 <Form>
//                     {/* Account Type */}
//                     <Form.Group controlId="type" className="mb-3">
//                         <Form.Label className='form-font'>Account Type <span className="text-danger">*</span></Form.Label>
//                         <Form.Select
//                             name='type'
//                             value={formData.type}
//                             onChange={handleChange}
//                             className={`form-feild ${errors.type ? 'is-invalid' : ''}`}
//                         >
//                             <option value="">Select</option>
//                             <option value="bank account">Bank Account</option>
//                             <option value="cash account">Cash Account</option>
//                         </Form.Select>
//                         {errors.type && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.type}</div>}
//                     </Form.Group>

//                     {/* Name */}
//                     <Form.Group controlId="name" className="mb-3">
//                         <Form.Label className='form-font'>Name <span className="text-danger">*</span></Form.Label>
//                         <Form.Control
//                             className={`form-feild form-control ${errors.name ? 'is-invalid' : ''}`}
//                             type="text"
//                             name="name"
//                             value={formData.name}
//                             onChange={handleChange}
//                             placeholder="Enter account name"
//                         />
//                         {errors.name && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.name}</div>}
//                     </Form.Group>

//                     {/* Bank Account Specific Fields */}
//                     {formData.type === 'bank account' && (
//                         <>
//                             <Form.Group controlId="branch_name" className="mb-3">
//                                 <Form.Label className='form-font'>Branch Name</Form.Label>
//                                 <Form.Control
//                                     className='form-control form-feild'
//                                     type="text"
//                                     name="branch_name"
//                                     value={formData.branch_name}
//                                     onChange={handleChange}
//                                     placeholder="Enter branch name"
//                                 />
//                             </Form.Group>

//                             <Form.Group controlId="account_holder_name" className="mb-3">
//                                 <Form.Label className='form-font'>Account Holder Name</Form.Label>
//                                 <Form.Control
//                                     className='form-control form-feild'
//                                     type="text"
//                                     name="account_holder_name"
//                                     value={formData.account_holder_name}
//                                     onChange={handleChange}
//                                     placeholder="Enter account holder name"
//                                 />
//                             </Form.Group>

//                             <Form.Group controlId="account_number" className="mb-3">
//                                 <Form.Label className='form-font'>Account Number</Form.Label>
//                                 <Form.Control
//                                     className='form-control form-feild'
//                                     type="text"
//                                     name="account_number"
//                                     value={formData.account_number}
//                                     onChange={handleChange}
//                                     placeholder="Enter account number"
//                                 />
//                             </Form.Group>

//                             <Form.Group controlId="iban" className="mb-3">
//                                 <Form.Label className='form-font'>IBAN</Form.Label>
//                                 <Form.Control
//                                     className='form-control form-feild'
//                                     type="text"
//                                     name="iban"
//                                     value={formData.iban}
//                                     onChange={handleChange}
//                                     placeholder="Enter IBAN"
//                                 />
//                             </Form.Group>

//                             <Form.Group className="mb-3" >
//                                 <Form.Label className='form-font'>SWIFT/BIC Code</Form.Label>
//                                 <Form.Control
//                                     className='form-control form-feild'
//                                     type="text"
//                                     name="swift_code"
//                                     value={formData.swift_code}
//                                     onChange={handleChange}
//                                     placeholder="Enter SWIFT/BIC code"
//                                 />
//                             </Form.Group>

//                             <Form.Group className="mb-3" >
//                                 <Form.Label className='form-font'>Bank Address</Form.Label>
//                                 <Form.Control
//                                     className='form-control form-feild'
//                                     as="textarea"
//                                     rows={2}
//                                     name="bank_address"
//                                     value={formData.bank_address}
//                                     onChange={handleChange}
//                                     placeholder="Enter bank address"
//                                 />
//                             </Form.Group>
//                         </>
//                     )}

//                     {/* Opening Balance */}
//                     <Form.Group className="mb-3" >
//                         <Form.Label className='form-font'>Opening Balance</Form.Label>
//                         <Form.Control
//                             className='form-control form-feild'
//                             type="number"
//                             step="0.01"
//                             name="opening_balance"
//                             value={formData.opening_balance}
//                             onChange={handleChange}
//                             placeholder="0.00"
//                         />
//                     </Form.Group>

//                     {/* Base Currency */}
//                     <Form.Group controlId="base_currency_id" className="mb-3">
//                         <Form.Label className='form-font'>Base Currency <span className="text-danger">*</span></Form.Label>
//                         <Form.Select
//                             className={`form-feild ${errors.base_currency_id ? 'is-invalid' : ''}`}
//                             name="base_currency_id"
//                             value={formData.base_currency_id}
//                             onChange={handleChange}
//                         >
//                             <option value="">Select Base Currency</option>
//                             {countries
//                                 ?.filter(country =>
//                                     (country.currency === 'AED' && country.name === 'United Arab Emirates') ||
//                                     (country.currency === 'USD' && country.name === 'United States')
//                                 )
//                                 .sort((a, b) => {
//                                     const order = ['AED', 'USD'];
//                                     return order.indexOf(a.currency) - order.indexOf(b.currency);
//                                 })
//                                 .map(country => (
//                                     <option key={country.id} value={country.id}>
//                                         {country.currency} ({country.name})
//                                     </option>
//                                 ))}

//                             {countries
//                                 ?.filter(country =>
//                                     !(
//                                         (country.currency === 'AED' && country.name === 'United Arab Emirates') ||
//                                         (country.currency === 'USD' && country.name === 'United States')
//                                     )
//                                 )
//                                 .map(country => (
//                                     <option key={country.id} value={country.id}>
//                                         {country.currency} ({country.name})
//                                     </option>
//                                 ))}
//                         </Form.Select>
//                         {errors.base_currency_id && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.base_currency_id}</div>}
//                         <Form.Text className="text-muted">
//                             This is the primary currency for this account
//                         </Form.Text>
//                     </Form.Group>

//                     {/* Exchange Rates Section */}
//                     <div className="mb-4">
//                         <div className="d-flex justify-content-between align-items-center mb-3">
//                             <Form.Label className='form-font mb-0'>Exchange Rates</Form.Label>
//                             <Button
//                                 variant="outline-primary"
//                                 size="sm"
//                                 onClick={addExchangeRate}
//                                 disabled={!formData.base_currency_id || getAvailableCurrencies().length === 0}
//                             >
//                                 <FaPlus /> Add Rate
//                             </Button>
//                         </div>

//                         {formData.exchange_rates.length > 0 && (
//                             <div className="mb-3">
//                                 <p className="text-muted small mb-2">
//                                     Exchange rates relative to base currency ({getCurrencyName(formData.base_currency_id)})
//                                 </p>
//                                 <div className="small text-muted mb-2">
//                                     Formula: 1 Foreign Currency = ? {getCurrencyName(formData.base_currency_id)}
//                                 </div>

//                             </div>
//                         )}

//                         {formData.exchange_rates.map((rate, index) => (
//                             <div key={index} className="border p-3 mb-3 rounded">
//                                 <Row className="g-2">
//                                     <Col md={6}>
//                                         <Form.Group>
//                                             <Form.Label className="small">Currency</Form.Label>
//                                             <Form.Select
//                                                 value={rate.currency_id}
//                                                 onChange={(e) => handleExchangeRateChange(index, 'currency_id', e.target.value)}
//                                                 className={`form-control-sm ${errors[`exchange_rate_currency_${index}`] ? 'is-invalid' : ''}`}
//                                                 size="sm"
//                                             >
//                                                 <option value="">Select Currency</option>
//                                                 {getAvailableCurrencies().map(country => (
//                                                     <option key={country.id} value={country.id}>
//                                                         {country.currency}
//                                                     </option>
//                                                 ))}
//                                             </Form.Select>
//                                             {errors[`exchange_rate_currency_${index}`] && (
//                                                 <div className="invalid-feedback d-block" style={{ fontSize: '10px' }}>
//                                                     {errors[`exchange_rate_currency_${index}`]}
//                                                 </div>
//                                             )}
//                                         </Form.Group>
//                                     </Col>
//                                     <Col md={5}>
//                                         <Form.Group>
//                                             <Form.Label className="small">Rate</Form.Label>
//                                             <Form.Control
//                                                 type="number"
//                                                 step="0.000001"
//                                                 value={rate.rate}
//                                                 onChange={(e) => handleExchangeRateChange(index, 'rate', e.target.value)}
//                                                 className={`form-control-sm ${errors[`exchange_rate_rate_${index}`] ? 'is-invalid' : ''}`}
//                                                 placeholder="e.g., 3.6725"
//                                                 size="sm"
//                                             />
//                                             {errors[`exchange_rate_rate_${index}`] && (
//                                                 <div className="invalid-feedback d-block" style={{ fontSize: '10px' }}>
//                                                     {errors[`exchange_rate_rate_${index}`]}
//                                                 </div>
//                                             )}
//                                         </Form.Group>
//                                     </Col>
//                                     <Col md={1} className="d-flex align-items-end">
//                                         <Button
//                                             variant="outline-danger"
//                                             size="sm"
//                                             onClick={() => removeExchangeRate(index)}
//                                             className="px-2"
//                                         >
//                                             <FaTrash />
//                                         </Button>
//                                     </Col>
//                                 </Row>
//                                 {rate.currency_id && rate.rate && (
//                                     <div className="small text-muted mt-2">
//                                         <strong>Rate:</strong> 1 {getCurrencyName(rate.currency_id)} = {parseFloat(rate.rate).toFixed(6)} {getCurrencyName(formData.base_currency_id)}
//                                     </div>
//                                 )}
//                             </div>
//                         ))}

//                         {formData.exchange_rates.length === 0 && (
//                             <div className="text-center text-muted py-4 border rounded bg-light">
//                                 <p className="mb-1">No exchange rates added yet</p>
//                                 <p className="small mb-0">Add exchange rates to convert between currencies</p>
//                                 <Button
//                                     variant="outline-primary"
//                                     size="sm"
//                                     onClick={addExchangeRate}
//                                     disabled={!formData.base_currency_id}
//                                     className="mt-2"
//                                 >
//                                     <FaPlus /> Add First Rate
//                                 </Button>
//                             </div>
//                         )}

//                         {formData.base_currency_id && getAvailableCurrencies().length === 0 && formData.exchange_rates.length === 0 && (
//                             <div className="alert alert-info small py-2">
//                                 All available currencies have been added as exchange rates.
//                             </div>
//                         )}
//                     </div>

//                 </Form>
//             </Offcanvas.Body>

//             {/* Footer with buttons */}
//             <div className="p-3 border-top d-flex justify-content-end">
//                 <button type="button" className="btn btn-secondary me-2" onClick={handleClose}>
//                     Cancel
//                 </button>
//                 <button type="button" className="btn btn-primary" onClick={handleSubmit} disabled={loading}>
//                     {loading ? (
//                         <>
//                             <Spinner animation="border" size="sm" className="me-2" />
//                             Saving...
//                         </>
//                     ) : (
//                         bankId ? 'Update Account' : 'Create Account'
//                     )}
//                 </button>
//             </div>
//         </Offcanvas>
//     );
// };

// export default BankForm;

// import React, { useState, useEffect } from 'react';
// import { Spinner, Offcanvas, Form, Button, Row, Col, Dropdown, InputGroup } from 'react-bootstrap';
// import axios from 'axios';
// import { FaPlus, FaTrash, FaSearch } from 'react-icons/fa';

// const BankForm = ({ showModal, handleClose, bankId, bankData, addBank, editBank, banks, countries, fetchCountries }) => {
//     const [loading, setLoading] = useState(false);
//     const [currencySearch, setCurrencySearch] = useState(''); // Add state for search
//     const [exchangeRateSearches, setExchangeRateSearches] = useState({}); // For individual exchange rate searches
//     const [formData, setFormData] = useState({
//         name: '',
//         branch_name: '',
//         account_holder_name: '',
//         account_number: '',
//         iban: '',
//         swift_code: '',
//         bank_address: '',
//         base_currency_id: '',
//         opening_balance: '',
//         type: '',
//         exchange_rates: []
//     });

//     const [errors, setErrors] = useState({});

//     // Initialize or reset form data
//     useEffect(() => {
//         if (showModal && countries.length === 0) {
//             fetchCountries();
//         }

//         if (showModal && !bankData) {
//             // Reset formData for new bank creation
//             setFormData({
//                 name: '',
//                 branch_name: '',
//                 account_holder_name: '',
//                 account_number: '',
//                 iban: '',
//                 swift_code: '',
//                 bank_address: '',
//                 base_currency_id: '',
//                 opening_balance: '',
//                 type: '',
//                 exchange_rates: []
//             });
//         } else if (bankData) {
//             // Populate formData for editing a bank
//             // Make sure exchange_rates is always an array
//             const exchangeRates = Array.isArray(bankData.exchange_rates) ? bankData.exchange_rates : [];

//             // FIX: Use currency_id if base_currency_id is not available
//             const baseCurrencyId = bankData.base_currency_id || bankData.currency_id || '';

//             setFormData({
//                 name: bankData.name || '',
//                 account_number: bankData.account_number || '',
//                 branch_name: bankData.branch_name || '',
//                 account_holder_name: bankData.account_holder_name || '',
//                 iban: bankData.iban || '',
//                 swift_code: bankData.swift_code || '',
//                 bank_address: bankData.bank_address || '',
//                 base_currency_id: baseCurrencyId, // FIX: Use the correct field
//                 opening_balance: bankData.opening_balance || '',
//                 type: bankData.type || '',
//                 exchange_rates: exchangeRates
//             });
//         }
//     }, [bankData, showModal]);

//     // Handle form field changes
//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prev) => ({ ...prev, [name]: value }));

//         if (errors[name]) {
//             setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
//         }
//     };

//     // Handle currency search change for base currency
//     const handleCurrencySearchChange = (e) => {
//         setCurrencySearch(e.target.value);
//     };

//     // Handle exchange rate currency search change
//     const handleExchangeRateSearchChange = (index, value) => {
//         setExchangeRateSearches(prev => ({
//             ...prev,
//             [index]: value
//         }));
//     };

//     // Filter countries based on search for base currency
//     const getFilteredCountries = (searchTerm = currencySearch) => {
//         if (!searchTerm) return countries;

//         const searchLower = searchTerm.toLowerCase();
//         return countries.filter(country =>
//             country.currency?.toLowerCase().includes(searchLower) ||
//             country.name?.toLowerCase().includes(searchLower) ||
//             country.currency_code?.toLowerCase().includes(searchLower)
//         );
//     };

//     // Filter available currencies for exchange rate
//     const getFilteredAvailableCurrencies = (searchTerm, index) => {
//         const availableCurrencies = getAvailableCurrencies();
//         if (!searchTerm) return availableCurrencies;

//         const searchLower = searchTerm.toLowerCase();
//         return availableCurrencies.filter(country =>
//             country.currency?.toLowerCase().includes(searchLower) ||
//             country.name?.toLowerCase().includes(searchLower) ||
//             country.currency_code?.toLowerCase().includes(searchLower)
//         );
//     };

//     // Handle exchange rate field changes
//     const handleExchangeRateChange = (index, field, value) => {
//         setFormData(prev => {
//             const updatedRates = [...prev.exchange_rates];
//             updatedRates[index] = {
//                 ...updatedRates[index],
//                 [field]: value
//             };
//             return { ...prev, exchange_rates: updatedRates };
//         });

//         // Clear search when a currency is selected
//         if (field === 'currency_id') {
//             setExchangeRateSearches(prev => ({
//                 ...prev,
//                 [index]: ''
//             }));
//         }
//     };

//     // Add new exchange rate row
//     const addExchangeRate = () => {
//         if (!formData.base_currency_id) {
//             alert('Please select base currency first');
//             return;
//         }

//         setFormData(prev => ({
//             ...prev,
//             exchange_rates: [
//                 ...prev.exchange_rates,
//                 {
//                     currency_id: '',
//                     rate: ''
//                 }
//             ]
//         }));
//     };

//     // Remove exchange rate row
//     const removeExchangeRate = (index) => {
//         setFormData(prev => ({
//             ...prev,
//             exchange_rates: prev.exchange_rates.filter((_, i) => i !== index)
//         }));

//         // Remove the search term for this index
//         setExchangeRateSearches(prev => {
//             const newSearches = { ...prev };
//             delete newSearches[index];
//             return newSearches;
//         });
//     };

//     // Get available currencies for exchange rates (excluding base currency and already selected currencies)
//     const getAvailableCurrencies = () => {
//         if (!formData.base_currency_id) {
//             return []; // Return empty if no base currency selected
//         }

//         // Filter out empty/null IDs
//         const selectedCurrencyIds = formData.exchange_rates
//             .map(rate => rate.currency_id)
//             .filter(id => id && id !== '' && id != null);

//         return countries.filter(country => {
//             // Skip if no country ID
//             if (!country || !country.id) return false;

//             // Skip if it's the base currency
//             if (country.id == formData.base_currency_id) return false;

//             // Skip if already selected
//             if (selectedCurrencyIds.includes(country.id)) return false;

//             return true;
//         });
//     };

//     // Get currency name by ID
//     const getCurrencyName = (currencyId) => {
//         const country = countries.find(c => c.id == currencyId);
//         return country ? (country.currency || country.currency_code) : '';
//     };

//     // Get currency details by ID
//     const getCurrencyDetails = (currencyId) => {
//         const country = countries.find(c => c.id == currencyId);
//         return country ? {
//             code: country.currency || country.currency_code,
//             name: country.name
//         } : null;
//     };

//     // Sort countries with USD, AED, INR first, then alphabetically
//     const sortCountries = (countriesList) => {
//         if (!countriesList || !Array.isArray(countriesList)) return [];

//         return [...countriesList].sort((a, b) => {
//             // Priority currencies in this order
//             const priorityOrder = ['USD', 'AED', 'INR'];
//             const aCurrency = a.currency || a.currency_code || '';
//             const bCurrency = b.currency || b.currency_code || '';

//             const aIndex = priorityOrder.indexOf(aCurrency);
//             const bIndex = priorityOrder.indexOf(bCurrency);

//             // If both are priority currencies, sort by priority order
//             if (aIndex !== -1 && bIndex !== -1) {
//                 return aIndex - bIndex;
//             }

//             // If only one is priority currency, it comes first
//             if (aIndex !== -1) return -1;
//             if (bIndex !== -1) return 1;

//             // Otherwise sort alphabetically by currency code
//             return aCurrency.localeCompare(bCurrency);
//         });
//     };

//     // Get grouped countries for the dropdown
//     const getGroupedCountries = () => {
//         const filteredCountries = getFilteredCountries();
//         const sortedCountries = sortCountries(filteredCountries);

//         // Group by priority and others
//         const priorityCurrencies = ['USD', 'AED', 'INR'];

//         const priorityCountries = sortedCountries.filter(country =>
//             priorityCurrencies.includes(country.currency || country.currency_code)
//         );

//         const otherCountries = sortedCountries.filter(country =>
//             !priorityCurrencies.includes(country.currency || country.currency_code)
//         );

//         return { priorityCountries, otherCountries };
//     };

//     // Custom dropdown component for exchange rate currency selection
//     const ExchangeRateCurrencyDropdown = ({ index, value, onChange, error }) => {
//         const searchTerm = exchangeRateSearches[index] || '';
//         const filteredCurrencies = getFilteredAvailableCurrencies(searchTerm, index);
//         const sortedCurrencies = sortCountries(filteredCurrencies);
//         const selectedCurrency = getCurrencyDetails(value);

//         return (
//             <Dropdown>
//                 <Dropdown.Toggle
//                     variant="outline-secondary"
//                     className="w-100 d-flex justify-content-between align-items-center text-start"
//                     size="sm"
//                 >
//                     {selectedCurrency ? (
//                         <span>{selectedCurrency.code} </span>
//                     ) : (
//                         <span className="text-muted">Select Currency</span>
//                     )}
//                 </Dropdown.Toggle>

//                 <Dropdown.Menu className="w-100" style={{ maxHeight: '300px', overflowY: 'auto' }}>
//                     {/* Search input inside dropdown */}
//                     <div className="p-2 border-bottom">
//                         <InputGroup size="sm">
//                             <InputGroup.Text>
//                                 <FaSearch />
//                             </InputGroup.Text>
//                             <Form.Control
//                                 type="text"
//                                 placeholder="Search currency..."
//                                 value={searchTerm}
//                                 onChange={(e) => handleExchangeRateSearchChange(index, e.target.value)}
//                                 onClick={(e) => e.stopPropagation()}
//                             />
//                         </InputGroup>
//                     </div>

//                     {/* Priority currencies */}
//                     {sortedCurrencies.filter(c => ['USD', 'AED', 'INR'].includes(c.currency || c.currency_code)).length > 0 && (
//                         <>
//                             <Dropdown.Header>Popular Currencies</Dropdown.Header>
//                             {sortedCurrencies
//                                 .filter(c => ['USD', 'AED', 'INR'].includes(c.currency || c.currency_code))
//                                 .map(country => (
//                                     <Dropdown.Item
//                                         key={country.id}
//                                         onClick={() => onChange(country.id)}
//                                         active={value === country.id}
//                                     >
//                                         {country.currency || country.currency_code} 
//                                     </Dropdown.Item>
//                                 ))}
//                             <Dropdown.Divider />
//                         </>
//                     )}

//                     {/* Other currencies */}
//                     {sortedCurrencies.filter(c => !['USD', 'AED', 'INR'].includes(c.currency || c.currency_code)).length > 0 ? (
//                         sortedCurrencies
//                             .filter(c => !['USD', 'AED', 'INR'].includes(c.currency || c.currency_code))
//                             .map(country => (
//                                 <Dropdown.Item
//                                     key={country.id}
//                                     onClick={() => onChange(country.id)}
//                                     active={value === country.id}
//                                 >
//                                     {country.currency || country.currency_code} 
//                                 </Dropdown.Item>
//                             ))
//                     ) : (
//                         <Dropdown.Item disabled>No currencies found</Dropdown.Item>
//                     )}
//                 </Dropdown.Menu>
//             </Dropdown>
//         );
//     };

//     // Validate form
//     const validateForm = () => {
//         const newErrors = {};

//         // Required fields
//         if (!formData.name) newErrors.name = '*Name is required';
//         if (!formData.type) newErrors.type = '*Account type is required';
//         if (!formData.base_currency_id) newErrors.base_currency_id = '*Base currency is required';

//         // Validate exchange rates
//         formData.exchange_rates.forEach((rate, index) => {
//             if (!rate.currency_id) {
//                 newErrors[`exchange_rate_currency_${index}`] = '*Currency is required';
//             }
//             if (!rate.rate || isNaN(parseFloat(rate.rate)) || parseFloat(rate.rate) <= 0) {
//                 newErrors[`exchange_rate_rate_${index}`] = '*Valid exchange rate is required';
//             }

//             // Check for duplicate currencies
//             const duplicateIndex = formData.exchange_rates.findIndex((r, i) =>
//                 i !== index && r.currency_id === rate.currency_id
//             );
//             if (duplicateIndex !== -1) {
//                 newErrors[`exchange_rate_currency_${index}`] = '*Currency already selected';
//             }
//         });

//         return newErrors;
//     };


//     const syncBankLedgerWithWebzash = async (bank, oldType = null, oldName = null) => {
//         const API = process.env.REACT_APP_WEBZASH_URL;
//         const backendUrl = `${API}/api`;
//         const headers = {
//             "x-api-key": process.env.REACT_APP_API_KEY,
//             Accept: "application/json",
//             "Content-Type": "application/json",
//         };

//         try {
//             const groupName =
//                 bank.type === "bank account"
//                     ? "Bank Accounts"
//                     : bank.type === "cash account"
//                         ? "Cash-in-Hand"
//                         : null;

//             if (!groupName) throw new Error("Invalid bank type");

//             // Fetch group list
//             const groupListResponse = await axios.get(`${backendUrl}/groups/index`, { headers });
//             let allGroups = Array.isArray(groupListResponse.data?.data)
//                 ? groupListResponse.data.data
//                 : Array.isArray(groupListResponse.data)
//                     ? groupListResponse.data
//                     : [];

//             if (!allGroups.length) throw new Error("Failed to fetch group list");

//             // Get parent group Assets
//             const parent = allGroups.find((g) =>
//                 g.Group?.name?.trim().toLowerCase() === "assets"
//             )?.Group;
//             if (!parent?.id) throw new Error("Assets group not found");

//             // Find or create the specific group (Bank Accounts or Cash-in-Hand)
//             let group = allGroups.find((g) =>
//                 g.Group?.name?.trim().toLowerCase() === groupName.toLowerCase()
//             )?.Group;

//             if (!group) {
//                 await axios.post(`${backendUrl}/groups/add`, {
//                     Group: {
//                         name: groupName,
//                         parent_id: parent.id,
//                         code: null,
//                         affects_gross: 0,
//                     }
//                 }, { headers });

//                 const refreshed = await axios.get(`${backendUrl}/groups/index`, { headers });
//                 allGroups = refreshed.data?.data || [];
//                 group = allGroups.find((g) =>
//                     g.Group?.name?.trim().toLowerCase() === groupName.toLowerCase()
//                 )?.Group;
//             }

//             if (!group?.id) throw new Error("Group creation failed");
//             console.log("Raw opening_balance:", bank.opening_balance);
//             console.log("Raw exchange_rate:", bank.exchange_rate);
//             console.log("Currency object:", bank.currency);
//             console.log("Currency code:", bank?.currency?.currency);


//             let convertedBalance = parseFloat(bank.opening_balance || 0);

//             // fallback to AED if anything missing
//             const exchangeRate = parseFloat(bank.exchange_rate || 1);
//             const bankCurrency = bank?.currency?.currency || bank?.currency || "AED"; // covers both string and object

//             console.log("Resolved currency:", bankCurrency);

//             if (bankCurrency !== "AED" && exchangeRate > 0) {
//                 convertedBalance = convertedBalance * exchangeRate;
//                 console.log("Converted Balance after applying exchange rate:", convertedBalance);
//             }


//             // Fetch ledgers
//             const ledgerRes = await axios.get(`${backendUrl}/ledgers/index`, { headers });
//             const allLedgers = ledgerRes.data?.data || [];

//             // Find by current name or old name
//             const existingLedger = allLedgers.find(
//                 (l) =>
//                     l.Ledger?.name?.trim().toLowerCase() === bank.name.trim().toLowerCase() ||
//                     (oldName && l.Ledger?.name?.trim().toLowerCase() === oldName.trim().toLowerCase())
//             );

//             if (existingLedger) {
//                 const currentGroupId = existingLedger.Ledger?.group_id;
//                 const needsGroupUpdate = oldType && oldType !== bank.type && currentGroupId !== group.id;
//                 const needsNameUpdate = existingLedger.Ledger.name?.trim() !== bank.name.trim();

//                 if (needsGroupUpdate || needsNameUpdate) {
//                     await axios.post(`${backendUrl}/ledgers/edit/${existingLedger.Ledger.id}`, {
//                         Ledger: {
//                             ...existingLedger.Ledger,
//                             name: bank.name,
//                             group_id: group.id,
//                             op_balance: convertedBalance,
//                             op_balance_dc: "D",
//                             notes: bank.branch_name || "",
//                             type: 1,
//                             reconciliation: 0,
//                         }
//                     }, { headers });
//                 }
//             } else {
//                 // Create ledger if not exists
//                 await axios.post(`${backendUrl}/ledgers/add`, {
//                     Ledger: {
//                         name: bank.name,
//                         code: null,
//                         group_id: group.id,
//                         op_balance: convertedBalance,
//                         op_balance_dc: "D",
//                         notes: bank.branch_name || "",
//                         type: 1,
//                         reconciliation: 0,
//                     }
//                 }, { headers });
//             }

//         } catch (err) {
//             console.error("Ledger sync failed:", err.message);
//             throw new Error("Ledger sync failed: " + err.message);
//         }
//     };

//     // Handle form submission
//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);
//         const validationErrors = validateForm();

//         if (Object.keys(validationErrors).length > 0) {
//             setErrors(validationErrors);
//             setLoading(false);
//             return;
//         }

//         try {
//             // Prepare data for API
//             const apiData = {
//                 ...formData,
//                 // Include currency_id for backward compatibility
//                 currency_id: formData.base_currency_id
//             };
//             if (bankData) {
//                 await syncBankLedgerWithWebzash({ ...formData, currency: bankData.currency }, bankData.type, bankData?.name); // edit mode
//             } else {
//                 await syncBankLedgerWithWebzash(formData);
//             }

//             let apiErrors;
//             if (bankData) {
//                 apiErrors = await editBank(bankData.id, apiData);
//             } else {
//                 apiErrors = await addBank(apiData);
//             }

//             if (apiErrors && Object.keys(apiErrors).length > 0) {
//                 setErrors(apiErrors);
//             } else {
//                 setErrors({});
//                 handleClose();
//             }
//         } catch (error) {
//             console.error("An error occurred:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Reset search when modal closes
//     useEffect(() => {
//         if (!showModal) {
//             setCurrencySearch('');
//             setExchangeRateSearches({});
//         }
//     }, [showModal]);

//     const { priorityCountries, otherCountries } = getGroupedCountries();

//     return (
//         <Offcanvas show={showModal} onHide={handleClose} placement="end" style={{ width: '580px' }}>
//             <Offcanvas.Header closeButton>
//                 <Offcanvas.Title>{bankId ? 'Edit Account' : 'Add Account'}</Offcanvas.Title>
//             </Offcanvas.Header>
//             <hr style={{ margin: 0 }} /><br />

//             <Offcanvas.Body>
//                 <Form>
//                     {/* Account Type */}
//                     <Form.Group controlId="type" className="mb-3">
//                         <Form.Label className='form-font'>Account Type <span className="text-danger">*</span></Form.Label>
//                         <Form.Select
//                             name='type'
//                             value={formData.type}
//                             onChange={handleChange}
//                             className={`form-feild ${errors.type ? 'is-invalid' : ''}`}
//                         >
//                             <option value="">Select</option>
//                             <option value="bank account">Bank Account</option>
//                             <option value="cash account">Cash Account</option>
//                         </Form.Select>
//                         {errors.type && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.type}</div>}
//                     </Form.Group>

//                     {/* Name */}
//                     <Form.Group controlId="name" className="mb-3">
//                         <Form.Label className='form-font'>Name <span className="text-danger">*</span></Form.Label>
//                         <Form.Control
//                             className={`form-feild form-control ${errors.name ? 'is-invalid' : ''}`}
//                             type="text"
//                             name="name"
//                             value={formData.name}
//                             onChange={handleChange}
//                             placeholder="Enter account name"
//                         />
//                         {errors.name && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.name}</div>}
//                     </Form.Group>

//                     {/* Bank Account Specific Fields */}
//                     {formData.type === 'bank account' && (
//                         <>
//                             <Form.Group controlId="branch_name" className="mb-3">
//                                 <Form.Label className='form-font'>Branch Name</Form.Label>
//                                 <Form.Control
//                                     className='form-control form-feild'
//                                     type="text"
//                                     name="branch_name"
//                                     value={formData.branch_name}
//                                     onChange={handleChange}
//                                     placeholder="Enter branch name"
//                                 />
//                             </Form.Group>

//                             <Form.Group controlId="account_holder_name" className="mb-3">
//                                 <Form.Label className='form-font'>Account Holder Name</Form.Label>
//                                 <Form.Control
//                                     className='form-control form-feild'
//                                     type="text"
//                                     name="account_holder_name"
//                                     value={formData.account_holder_name}
//                                     onChange={handleChange}
//                                     placeholder="Enter account holder name"
//                                 />
//                             </Form.Group>

//                             <Form.Group controlId="account_number" className="mb-3">
//                                 <Form.Label className='form-font'>Account Number</Form.Label>
//                                 <Form.Control
//                                     className='form-control form-feild'
//                                     type="text"
//                                     name="account_number"
//                                     value={formData.account_number}
//                                     onChange={handleChange}
//                                     placeholder="Enter account number"
//                                 />
//                             </Form.Group>

//                             <Form.Group controlId="iban" className="mb-3">
//                                 <Form.Label className='form-font'>IBAN</Form.Label>
//                                 <Form.Control
//                                     className='form-control form-feild'
//                                     type="text"
//                                     name="iban"
//                                     value={formData.iban}
//                                     onChange={handleChange}
//                                     placeholder="Enter IBAN"
//                                 />
//                             </Form.Group>

//                             <Form.Group className="mb-3" >
//                                 <Form.Label className='form-font'>SWIFT/BIC Code</Form.Label>
//                                 <Form.Control
//                                     className='form-control form-feild'
//                                     type="text"
//                                     name="swift_code"
//                                     value={formData.swift_code}
//                                     onChange={handleChange}
//                                     placeholder="Enter SWIFT/BIC code"
//                                 />
//                             </Form.Group>

//                             <Form.Group className="mb-3" >
//                                 <Form.Label className='form-font'>Bank Address</Form.Label>
//                                 <Form.Control
//                                     className='form-control form-feild'
//                                     as="textarea"
//                                     rows={2}
//                                     name="bank_address"
//                                     value={formData.bank_address}
//                                     onChange={handleChange}
//                                     placeholder="Enter bank address"
//                                 />
//                             </Form.Group>
//                         </>
//                     )}

//                     {/* Opening Balance */}
//                     <Form.Group className="mb-3" >
//                         <Form.Label className='form-font'>Opening Balance</Form.Label>
//                         <Form.Control
//                             className='form-control form-feild'
//                             type="number"
//                             step="0.01"
//                             name="opening_balance"
//                             value={formData.opening_balance}
//                             onChange={handleChange}
//                             placeholder="0.00"
//                         />
//                     </Form.Group>

//                     {/* Base Currency with Search */}
//                     <Form.Group controlId="base_currency_id" className="mb-3">
//                         <Form.Label className='form-font'>Base Currency <span className="text-danger">*</span></Form.Label>



//                         <Form.Select
//                             className={`form-feild ${errors.base_currency_id ? 'is-invalid' : ''}`}
//                             name="base_currency_id"
//                             value={formData.base_currency_id}
//                             onChange={handleChange}
//                         >
//                             <option value="">Select Base Currency</option>

//                             {/* Priority Currencies Group */}
//                             {priorityCountries.length > 0 && (
//                                 <optgroup label="Popular Currencies">
//                                     {priorityCountries.map(country => (
//                                         <option key={country.id} value={country.id}>
//                                             {country.currency || country.currency_code} - {country.name}
//                                         </option>
//                                     ))}
//                                 </optgroup>
//                             )}

//                             {/* Other Currencies Group */}
//                             {otherCountries.length > 0 && (
//                                 <optgroup label="Other Currencies">
//                                     {otherCountries.map(country => (
//                                         <option key={country.id} value={country.id}>
//                                             {country.currency || country.currency_code} - {country.name}
//                                         </option>
//                                     ))}
//                                 </optgroup>
//                             )}

//                             {/* No results message */}
//                             {priorityCountries.length === 0 && otherCountries.length === 0 && (
//                                 <option disabled>No currencies found</option>
//                             )}
//                         </Form.Select>
//                         {errors.base_currency_id && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.base_currency_id}</div>}
//                         <Form.Text className="text-muted">
//                             This is the primary currency for this account
//                         </Form.Text>
//                     </Form.Group>

//                     {/* Exchange Rates Section */}
//                     <div className="mb-4">
//                         <div className="d-flex justify-content-between align-items-center mb-3">
//                             <Form.Label className='form-font mb-0'>Exchange Rates</Form.Label>
//                             <Button
//                                 variant="outline-primary"
//                                 size="sm"
//                                 onClick={addExchangeRate}
//                                 disabled={!formData.base_currency_id || getAvailableCurrencies().length === 0}
//                             >
//                                 <FaPlus /> Add Rate
//                             </Button>
//                         </div>

//                         {formData.exchange_rates.length > 0 && (
//                             <div className="mb-3">
//                                 <p className="text-muted small mb-2">
//                                     Exchange rates relative to base currency ({getCurrencyName(formData.base_currency_id)})
//                                 </p>
//                                 <div className="small text-muted mb-2">
//                                     Formula: 1 Foreign Currency = ? {getCurrencyName(formData.base_currency_id)}
//                                 </div>
//                             </div>
//                         )}

//                         {formData.exchange_rates.map((rate, index) => (
//                             <div key={index} className="border p-3 mb-3 rounded">
//                                 <Row className="g-2">
//                                     <Col md={6}>
//                                         <Form.Group>
//                                             <Form.Label className="small">Currency</Form.Label>
//                                             <ExchangeRateCurrencyDropdown
//                                                 index={index}
//                                                 value={rate.currency_id}
//                                                 onChange={(currencyId) => handleExchangeRateChange(index, 'currency_id', currencyId)}
//                                                 error={errors[`exchange_rate_currency_${index}`]}
//                                             />
//                                             {errors[`exchange_rate_currency_${index}`] && (
//                                                 <div className="invalid-feedback d-block" style={{ fontSize: '10px' }}>
//                                                     {errors[`exchange_rate_currency_${index}`]}
//                                                 </div>
//                                             )}
//                                         </Form.Group>
//                                     </Col>
//                                     <Col md={5}>
//                                         <Form.Group>
//                                             <Form.Label className="small">Rate</Form.Label>
//                                             <Form.Control
//                                                 type="number"
//                                                 step="0.000001"
//                                                 value={rate.rate}
//                                                 onChange={(e) => handleExchangeRateChange(index, 'rate', e.target.value)}
//                                                 className={`form-control-sm ${errors[`exchange_rate_rate_${index}`] ? 'is-invalid' : ''}`}
//                                                 placeholder="e.g., 3.6725"
//                                                 size="sm"
//                                             />
//                                             {errors[`exchange_rate_rate_${index}`] && (
//                                                 <div className="invalid-feedback d-block" style={{ fontSize: '10px' }}>
//                                                     {errors[`exchange_rate_rate_${index}`]}
//                                                 </div>
//                                             )}
//                                         </Form.Group>
//                                     </Col>
//                                     <Col md={1} className="d-flex align-items-end">
//                                         <Button
//                                             variant="outline-danger"
//                                             size="sm"
//                                             onClick={() => removeExchangeRate(index)}
//                                             className="px-2"
//                                         >
//                                             <FaTrash />
//                                         </Button>
//                                     </Col>
//                                 </Row>
//                                 {rate.currency_id && rate.rate && (
//                                     <div className="small text-muted mt-2">
//                                         <strong>Rate:</strong> 1 {getCurrencyName(rate.currency_id)} = {parseFloat(rate.rate).toFixed(6)} {getCurrencyName(formData.base_currency_id)}
//                                     </div>
//                                 )}
//                             </div>
//                         ))}

//                         {formData.exchange_rates.length === 0 && (
//                             <div className="text-center text-muted py-4 border rounded bg-light">
//                                 <p className="mb-1">No exchange rates added yet</p>
//                                 <p className="small mb-0">Add exchange rates to convert between currencies</p>
//                                 <Button
//                                     variant="outline-primary"
//                                     size="sm"
//                                     onClick={addExchangeRate}
//                                     disabled={!formData.base_currency_id}
//                                     className="mt-2"
//                                 >
//                                     <FaPlus /> Add First Rate
//                                 </Button>
//                             </div>
//                         )}

//                         {formData.base_currency_id && getAvailableCurrencies().length === 0 && formData.exchange_rates.length === 0 && (
//                             <div className="alert alert-info small py-2">
//                                 All available currencies have been added as exchange rates.
//                             </div>
//                         )}
//                     </div>

//                 </Form>
//             </Offcanvas.Body>

//             {/* Footer with buttons */}
//             <div className="p-3 border-top d-flex justify-content-end">
//                 <button type="button" className="btn btn-secondary me-2" onClick={handleClose}>
//                     Cancel
//                 </button>
//                 <button type="button" className="btn btn-primary" onClick={handleSubmit} disabled={loading}>
//                     {loading ? (
//                         <>
//                             <Spinner animation="border" size="sm" className="me-2" />
//                             Saving...
//                         </>
//                     ) : (
//                         bankId ? 'Update Account' : 'Create Account'
//                     )}
//                 </button>
//             </div>
//         </Offcanvas>
//     );
// };

// export default BankForm;

import React, { useState, useEffect } from 'react';
import { Spinner, Offcanvas, Form, Button, Row, Col, Dropdown, InputGroup } from 'react-bootstrap';
import axios from 'axios';
import { FaPlus, FaTrash, FaSearch } from 'react-icons/fa';

const BankForm = ({ showModal, handleClose, bankId, bankData, addBank, editBank, banks, countries, fetchCountries }) => {
    const [loading, setLoading] = useState(false);
    const [currencySearch, setCurrencySearch] = useState(''); // Add state for search
    const [exchangeRateSearches, setExchangeRateSearches] = useState({}); // For individual exchange rate searches
    const [formData, setFormData] = useState({
        name: '',
        branch_name: '',
        account_holder_name: '',
        account_number: '',
        iban: '',
        swift_code: '',
        bank_address: '',
        base_currency_id: '',
        opening_balance: '',
        type: '',
        exchange_rates: [],
        is_payroll_provider: false
    });

    const [errors, setErrors] = useState({});

    // Initialize or reset form data
    useEffect(() => {
        if (showModal && countries.length === 0) {
            fetchCountries();
        }

        if (showModal && !bankData) {
            // Reset formData for new bank creation
            setFormData({
                name: '',
                branch_name: '',
                account_holder_name: '',
                account_number: '',
                iban: '',
                swift_code: '',
                bank_address: '',
                base_currency_id: '',
                opening_balance: '',
                type: '',
                exchange_rates: [],
                is_payroll_provider: false
            });
        } else if (bankData) {
            // Populate formData for editing a bank
            // Make sure exchange_rates is always an array
            const exchangeRates = Array.isArray(bankData.exchange_rates) ? bankData.exchange_rates : [];

            // FIX: Use currency_id if base_currency_id is not available
            const baseCurrencyId = bankData.base_currency_id || bankData.currency_id || '';

            setFormData({
                name: bankData.name || '',
                account_number: bankData.account_number || '',
                branch_name: bankData.branch_name || '',
                account_holder_name: bankData.account_holder_name || '',
                iban: bankData.iban || '',
                swift_code: bankData.swift_code || '',
                bank_address: bankData.bank_address || '',
                base_currency_id: baseCurrencyId, // FIX: Use the correct field
                opening_balance: bankData.opening_balance || '',
                type: bankData.type || '',
                exchange_rates: exchangeRates,
                is_payroll_provider: bankData.is_payroll_provider || false
            });
        }
    }, [bankData, showModal]);

    // Handle form field changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));

        if (errors[name]) {
            setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
        }
    };

    // Handle currency search change for base currency
    const handleCurrencySearchChange = (e) => {
        setCurrencySearch(e.target.value);
    };

    // Handle exchange rate currency search change
    const handleExchangeRateSearchChange = (index, value) => {
        setExchangeRateSearches(prev => ({
            ...prev,
            [index]: value
        }));
    };

    // Filter countries based on search for base currency
    const getFilteredCountries = (searchTerm = currencySearch) => {
        if (!searchTerm) return countries;

        const searchLower = searchTerm.toLowerCase();
        return countries.filter(country =>
            country.currency?.toLowerCase().includes(searchLower) ||
            country.name?.toLowerCase().includes(searchLower) ||
            country.currency_code?.toLowerCase().includes(searchLower)
        );
    };

    // Filter available currencies for exchange rate
    const getFilteredAvailableCurrencies = (searchTerm, index) => {
        const availableCurrencies = getAvailableCurrencies();
        if (!searchTerm) return availableCurrencies;

        const searchLower = searchTerm.toLowerCase();
        return availableCurrencies.filter(country =>
            country.currency?.toLowerCase().includes(searchLower) ||
            country.name?.toLowerCase().includes(searchLower) ||
            country.currency_code?.toLowerCase().includes(searchLower)
        );
    };

    // Handle exchange rate field changes
    const handleExchangeRateChange = (index, field, value) => {
        setFormData(prev => {
            const updatedRates = [...prev.exchange_rates];
            updatedRates[index] = {
                ...updatedRates[index],
                [field]: value
            };
            return { ...prev, exchange_rates: updatedRates };
        });

        // Clear search when a currency is selected
        if (field === 'currency_id') {
            setExchangeRateSearches(prev => ({
                ...prev,
                [index]: ''
            }));
        }
    };

    // Add new exchange rate row
    const addExchangeRate = () => {
        if (!formData.base_currency_id) {
            alert('Please select base currency first');
            return;
        }

        setFormData(prev => ({
            ...prev,
            exchange_rates: [
                ...prev.exchange_rates,
                {
                    currency_id: '',
                    rate: ''
                }
            ]
        }));
    };

    // Remove exchange rate row
    const removeExchangeRate = (index) => {
        setFormData(prev => ({
            ...prev,
            exchange_rates: prev.exchange_rates.filter((_, i) => i !== index)
        }));

        // Remove the search term for this index
        setExchangeRateSearches(prev => {
            const newSearches = { ...prev };
            delete newSearches[index];
            return newSearches;
        });
    };

    // Get available currencies for exchange rates (excluding base currency and already selected currencies)
    const getAvailableCurrencies = () => {
        if (!formData.base_currency_id) {
            return []; // Return empty if no base currency selected
        }

        // Filter out empty/null IDs
        const selectedCurrencyIds = formData.exchange_rates
            .map(rate => rate.currency_id)
            .filter(id => id && id !== '' && id != null);

        return countries.filter(country => {
            // Skip if no country ID
            if (!country || !country.id) return false;

            // Skip if it's the base currency
            if (country.id == formData.base_currency_id) return false;

            // Skip if already selected
            if (selectedCurrencyIds.includes(country.id)) return false;

            return true;
        });
    };

    // Get currency name by ID
    const getCurrencyName = (currencyId) => {
        const country = countries.find(c => c.id == currencyId);
        return country ? (country.currency || country.currency_code) : '';
    };

    // Get currency details by ID
    const getCurrencyDetails = (currencyId) => {
        const country = countries.find(c => c.id == currencyId);
        return country ? {
            code: country.currency || country.currency_code,
            name: country.name
        } : null;
    };

    // Get specific countries for priority currencies
    const getPriorityCountries = () => {
        const specificCountries = [];

        // Find United Arab Emirates for AED
        const aedCountry = countries.find(c =>
            (c.currency === 'AED' || c.currency_code === 'AED') &&
            c.name === 'United Arab Emirates'
        );
        if (aedCountry) specificCountries.push(aedCountry);

        // Find United States for USD
        const usdCountry = countries.find(c =>
            (c.currency === 'USD' || c.currency_code === 'USD') &&
            c.name === 'United States'
        );
        if (usdCountry) specificCountries.push(usdCountry);

        // Find India for INR
        const inrCountry = countries.find(c =>
            (c.currency === 'INR' || c.currency_code === 'INR') &&
            c.name === 'India'
        );
        if (inrCountry) specificCountries.push(inrCountry);

        return specificCountries;
    };

    // Get other countries (excluding the specific priority ones)
    const getOtherCountries = (filteredCountries) => {
        const priorityCountries = getPriorityCountries();
        const priorityCountryIds = priorityCountries.map(c => c.id);

        return filteredCountries.filter(country =>
            !priorityCountryIds.includes(country.id)
        );
    };

    // Sort countries with specific AED, USD, INR first, then alphabetically
    const sortCountries = (countriesList) => {
        if (!countriesList || !Array.isArray(countriesList)) return [];

        // Get priority countries in specific order
        const priorityOrder = [
            { currency: 'AED', country: 'United Arab Emirates' },
            { currency: 'USD', country: 'United States' },
            { currency: 'INR', country: 'India' }
        ];

        return [...countriesList].sort((a, b) => {
            const aCurrency = a.currency || a.currency_code || '';
            const aName = a.name || '';
            const bCurrency = b.currency || b.currency_code || '';
            const bName = b.name || '';

            // Check if a is a priority country
            const aPriorityIndex = priorityOrder.findIndex(p =>
                aCurrency === p.currency && aName === p.country
            );

            // Check if b is a priority country
            const bPriorityIndex = priorityOrder.findIndex(p =>
                bCurrency === p.currency && bName === p.country
            );

            // If both are priority countries, sort by priority order
            if (aPriorityIndex !== -1 && bPriorityIndex !== -1) {
                return aPriorityIndex - bPriorityIndex;
            }

            // If only a is priority, it comes first
            if (aPriorityIndex !== -1) return -1;

            // If only b is priority, b comes first
            if (bPriorityIndex !== -1) return 1;

            // Otherwise sort alphabetically by currency code
            return aCurrency.localeCompare(bCurrency);
        });
    };

    // Get grouped countries for the dropdown
    const getGroupedCountries = () => {
        const filteredCountries = getFilteredCountries();
        const priorityCountries = getPriorityCountries();
        const otherCountries = getOtherCountries(filteredCountries);

        return { priorityCountries, otherCountries };
    };

    // Get available currencies sorted with priority first
    const getSortedAvailableCurrencies = (searchTerm, index) => {
        const filteredCurrencies = getFilteredAvailableCurrencies(searchTerm, index);
        return sortCountries(filteredCurrencies);
    };

    // Custom dropdown component for exchange rate currency selection
    const ExchangeRateCurrencyDropdown = ({ index, value, onChange, error }) => {
        const searchTerm = exchangeRateSearches[index] || '';
        const sortedCurrencies = getSortedAvailableCurrencies(searchTerm, index);
        const selectedCurrency = getCurrencyDetails(value);

        // Separate priority and other currencies
        const priorityCurrenciesList = getPriorityCountries().filter(pc =>
            sortedCurrencies.some(c => c.id === pc.id)
        );

        const otherCurrenciesList = sortedCurrencies.filter(c =>
            !priorityCurrenciesList.some(pc => pc.id === c.id)
        );

        return (
            <Dropdown>
                <Dropdown.Toggle
                    variant="outline-secondary"
                    className="w-100 d-flex justify-content-between align-items-center text-start"
                    size="sm"
                >
                    {selectedCurrency ? (
                        <span>{selectedCurrency.code}</span>
                    ) : (
                        <span className="text-muted">Select Currency</span>
                    )}
                </Dropdown.Toggle>

                <Dropdown.Menu className="w-100" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                    {/* Search input inside dropdown */}
                    <div className="p-2 border-bottom">
                        <InputGroup size="sm">
                            <InputGroup.Text>
                                <FaSearch />
                            </InputGroup.Text>
                            <Form.Control
                                type="text"
                                placeholder="Search currency..."
                                value={searchTerm}
                                onChange={(e) => handleExchangeRateSearchChange(index, e.target.value)}
                                onClick={(e) => e.stopPropagation()}
                            />
                        </InputGroup>
                    </div>

                    {/* Priority currencies */}
                    {priorityCurrenciesList.length > 0 && (
                        <>
                            <Dropdown.Header>Popular Currencies</Dropdown.Header>
                            {priorityCurrenciesList.map(country => (
                                <Dropdown.Item
                                    key={country.id}
                                    onClick={() => onChange(country.id)}
                                    active={value === country.id}
                                >
                                    {country.currency || country.currency_code}
                                </Dropdown.Item>
                            ))}
                            <Dropdown.Divider />
                        </>
                    )}

                    {/* Other currencies */}
                    {otherCurrenciesList.length > 0 ? (
                        otherCurrenciesList.map(country => (
                            <Dropdown.Item
                                key={country.id}
                                onClick={() => onChange(country.id)}
                                active={value === country.id}
                            >
                                {country.currency || country.currency_code}
                            </Dropdown.Item>
                        ))
                    ) : (
                        <Dropdown.Item disabled>No currencies found</Dropdown.Item>
                    )}
                </Dropdown.Menu>
            </Dropdown>
        );
    };

    // Validate form
    const validateForm = () => {
        const newErrors = {};

        // Required fields
        if (!formData.name) newErrors.name = '*Name is required';
        if (!formData.type) newErrors.type = '*Account type is required';
        if (!formData.base_currency_id) newErrors.base_currency_id = '*Base currency is required';

        // Validate exchange rates
        formData.exchange_rates.forEach((rate, index) => {
            if (!rate.currency_id) {
                newErrors[`exchange_rate_currency_${index}`] = '*Currency is required';
            }
            if (!rate.rate || isNaN(parseFloat(rate.rate)) || parseFloat(rate.rate) <= 0) {
                newErrors[`exchange_rate_rate_${index}`] = '*Valid exchange rate is required';
            }

            // Check for duplicate currencies
            const duplicateIndex = formData.exchange_rates.findIndex((r, i) =>
                i !== index && r.currency_id === rate.currency_id
            );
            if (duplicateIndex !== -1) {
                newErrors[`exchange_rate_currency_${index}`] = '*Currency already selected';
            }
        });

        return newErrors;
    };

    const syncBankLedgerWithWebzash = async (bank, oldType = null, oldName = null) => {
        const API = process.env.REACT_APP_WEBZASH_URL;
        const backendUrl = `${API}/api`;
        const headers = {
            "x-api-key": process.env.REACT_APP_API_KEY,
            Accept: "application/json",
            "Content-Type": "application/json",
        };

        try {
            const groupName =
                bank.type === "bank account"
                    ? "Bank Accounts"
                    : bank.type === "cash account"
                        ? "Cash-in-Hand"
                        : null;

            if (!groupName) throw new Error("Invalid bank type");

            // Fetch group list
            const groupListResponse = await axios.get(`${backendUrl}/groups/index`, { headers });
            let allGroups = Array.isArray(groupListResponse.data?.data)
                ? groupListResponse.data.data
                : Array.isArray(groupListResponse.data)
                    ? groupListResponse.data
                    : [];

            if (!allGroups.length) throw new Error("Failed to fetch group list");

            // Get parent group Assets
            const parent = allGroups.find((g) =>
                g.Group?.name?.trim().toLowerCase() === "assets"
            )?.Group;
            if (!parent?.id) throw new Error("Assets group not found");

            // Find or create the specific group (Bank Accounts or Cash-in-Hand)
            let group = allGroups.find((g) =>
                g.Group?.name?.trim().toLowerCase() === groupName.toLowerCase()
            )?.Group;

            if (!group) {
                await axios.post(`${backendUrl}/groups/add`, {
                    Group: {
                        name: groupName,
                        parent_id: parent.id,
                        code: null,
                        affects_gross: 0,
                    }
                }, { headers });

                const refreshed = await axios.get(`${backendUrl}/groups/index`, { headers });
                allGroups = refreshed.data?.data || [];
                group = allGroups.find((g) =>
                    g.Group?.name?.trim().toLowerCase() === groupName.toLowerCase()
                )?.Group;
            }

            if (!group?.id) throw new Error("Group creation failed");

            // Calculate opening balance properly
            // Note: In Webzash, opening balance is typically in base currency
            // If the bank is in foreign currency, opening balance needs to be handled carefully
            let openingBalance = parseFloat(bank.opening_balance || 0);

            // Fetch ledgers
            const ledgerRes = await axios.get(`${backendUrl}/ledgers/index`, { headers });
            const allLedgers = ledgerRes.data?.data || [];

            // Find by current name or old name (if editing)
            // Prioritize finding by oldName if provided, otherwise check if name already exists
            let existingLedger = null;

            if (oldName) {
                // Try to find by old name first
                existingLedger = allLedgers.find(
                    (l) => l.Ledger?.name?.trim().toLowerCase() === oldName.trim().toLowerCase()
                );
            }

            // If not found by old name, try current name
            if (!existingLedger) {
                existingLedger = allLedgers.find(
                    (l) => l.Ledger?.name?.trim().toLowerCase() === bank.name.trim().toLowerCase()
                );
            }

            const ledgerData = {
                name: bank.name,
                group_id: group.id,
                op_balance: openingBalance,
                op_balance_dc: "D",
                notes: bank.branch_name || "",
                type: 1,
                reconciliation: 0,
            };

            if (existingLedger) {
                const currentGroupId = existingLedger.Ledger?.group_id;
                const currentName = existingLedger.Ledger?.name || '';

                // Determine if update is needed:
                // 1. Group ID changed (e.g. moved from Bank -> Cash)
                // 2. Name changed (e.g. renamed bank account)
                // 3. Opening balance or other details updated (though we focus on name/group mostly)

                const needsGroupUpdate = oldType && oldType !== bank.type && currentGroupId !== group.id;
                const needsNameUpdate = currentName.trim() !== bank.name.trim();

                // Even if name/group didn't change, we might want to update other fields like notes/balance
                // So execute update if we found the ledger

                console.log(`Updating existing ledger: ID ${existingLedger.Ledger.id}, Name: ${currentName} -> ${bank.name}`);

                await axios.post(`${backendUrl}/ledgers/edit/${existingLedger.Ledger.id}`, {
                    Ledger: {
                        ...existingLedger.Ledger,
                        ...ledgerData
                    }
                }, { headers });

                console.log('Ledger updated successfully');
            } else {
                // Create ledger if not exists
                console.log(`Creating new ledger: ${bank.name}`);

                await axios.post(`${backendUrl}/ledgers/add`, {
                    Ledger: {
                        ...ledgerData,
                        code: null,
                    }
                }, { headers });

                console.log('Ledger created successfully');
            }

        } catch (err) {
            console.error("Ledger sync failed:", err.message);
            // Non-blocking error - we log it but don't stop the bank creation/update flow
            // But we might want to alert the user
            console.warn("Continuing despite ledger sync failure");
        }
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const validationErrors = validateForm();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return;
        }

        try {
            // Prepare data for API
            const apiData = {
                ...formData,
                // Include currency_id for backward compatibility
                currency_id: formData.base_currency_id
            };
            if (bankData) {
                await syncBankLedgerWithWebzash({ ...formData, currency: bankData.currency }, bankData.type, bankData?.name); // edit mode
            } else {
                await syncBankLedgerWithWebzash(formData);
            }

            let apiErrors;
            if (bankData) {
                apiErrors = await editBank(bankData.id, apiData);
            } else {
                apiErrors = await addBank(apiData);
            }

            if (apiErrors && Object.keys(apiErrors).length > 0) {
                setErrors(apiErrors);
            } else {
                setErrors({});
                handleClose();
            }
        } catch (error) {
            console.error("An error occurred:", error);
        } finally {
            setLoading(false);
        }
    };

    // Reset search when modal closes
    useEffect(() => {
        if (!showModal) {
            setCurrencySearch('');
            setExchangeRateSearches({});
        }
    }, [showModal]);

    const { priorityCountries, otherCountries } = getGroupedCountries();

    return (
        <Offcanvas show={showModal} onHide={handleClose} placement="end" style={{ width: '580px' }}>
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>{bankId ? 'Edit Account' : 'Add Account'}</Offcanvas.Title>
            </Offcanvas.Header>
            <hr style={{ margin: 0 }} /><br />

            <Offcanvas.Body>
                <Form>
                    {/* Account Type */}
                    <Form.Group controlId="type" className="mb-3">
                        <Form.Label className='form-font'>Account Type <span className="text-danger">*</span></Form.Label>
                        <Form.Select
                            name='type'
                            value={formData.type}
                            onChange={handleChange}
                            className={`form-feild ${errors.type ? 'is-invalid' : ''}`}
                        >
                            <option value="">Select</option>
                            <option value="bank account">Bank Account</option>
                            <option value="cash account">Cash Account</option>
                        </Form.Select>
                        {errors.type && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.type}</div>}
                    </Form.Group>

                    {/* Name */}
                    <Form.Group controlId="name" className="mb-3">
                        <Form.Label className='form-font'>Name <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            className={`form-feild form-control ${errors.name ? 'is-invalid' : ''}`}
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Enter account name"
                        />
                        {errors.name && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.name}</div>}
                    </Form.Group>

                    {/* Bank Account Specific Fields */}
                    {formData.type === 'bank account' && (
                        <>
                            <Form.Group controlId="branch_name" className="mb-3">
                                <Form.Label className='form-font'>Branch Name</Form.Label>
                                <Form.Control
                                    className='form-control form-feild'
                                    type="text"
                                    name="branch_name"
                                    value={formData.branch_name}
                                    onChange={handleChange}
                                    placeholder="Enter branch name"
                                />
                            </Form.Group>

                            <Form.Group controlId="account_holder_name" className="mb-3">
                                <Form.Label className='form-font'>Account Holder Name</Form.Label>
                                <Form.Control
                                    className='form-control form-feild'
                                    type="text"
                                    name="account_holder_name"
                                    value={formData.account_holder_name}
                                    onChange={handleChange}
                                    placeholder="Enter account holder name"
                                />
                            </Form.Group>

                            <Form.Group controlId="account_number" className="mb-3">
                                <Form.Label className='form-font'>Account Number</Form.Label>
                                <Form.Control
                                    className='form-control form-feild'
                                    type="text"
                                    name="account_number"
                                    value={formData.account_number}
                                    onChange={handleChange}
                                    placeholder="Enter account number"
                                />
                            </Form.Group>

                            <Form.Group controlId="iban" className="mb-3">
                                <Form.Label className='form-font'>IBAN</Form.Label>
                                <Form.Control
                                    className='form-control form-feild'
                                    type="text"
                                    name="iban"
                                    value={formData.iban}
                                    onChange={handleChange}
                                    placeholder="Enter IBAN"
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" >
                                <Form.Label className='form-font'>SWIFT/BIC Code</Form.Label>
                                <Form.Control
                                    className='form-control form-feild'
                                    type="text"
                                    name="swift_code"
                                    value={formData.swift_code}
                                    onChange={handleChange}
                                    placeholder="Enter SWIFT/BIC code"
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" >
                                <Form.Label className='form-font'>Bank Address</Form.Label>
                                <Form.Control
                                    className='form-control form-feild'
                                    as="textarea"
                                    rows={2}
                                    name="bank_address"
                                    value={formData.bank_address}
                                    onChange={handleChange}
                                    placeholder="Enter bank address"
                                />
                            </Form.Group>
                        </>
                    )}

                    {/* Opening Balance */}
                    <Form.Group className="mb-3" >
                        <Form.Label className='form-font'>Opening Balance</Form.Label>
                        <Form.Control
                            className='form-control form-feild'
                            type="number"
                            step="0.01"
                            name="opening_balance"
                            value={formData.opening_balance}
                            onChange={handleChange}
                            placeholder="0.00"
                        />
                    </Form.Group>
                    <div className="mb-4 border p-3 rounded">
                        <Form.Group controlId="is_payroll_provider" className="mb-3">
                            <Form.Check
                                type="checkbox"
                                label="Add to Payroll Provider"
                                name="is_payroll_provider"
                                checked={formData.is_payroll_provider}
                                onChange={handleChange}
                                className="form-check"
                            />
                            <Form.Text className="text-muted">
                                Check this if this bank account should be available for payroll processing
                            </Form.Text>
                        </Form.Group>
                    </div>

                    {/* Base Currency with Search */}
                    <Form.Group controlId="base_currency_id" className="mb-3">
                        <Form.Label className='form-font'>Base Currency <span className="text-danger">*</span></Form.Label>



                        <Form.Select
                            className={`form-feild ${errors.base_currency_id ? 'is-invalid' : ''}`}
                            name="base_currency_id"
                            value={formData.base_currency_id}
                            onChange={handleChange}
                        >
                            <option value="">Select Base Currency</option>

                            {/* Priority Currencies Group - Only specific countries */}
                            {priorityCountries.length > 0 && (
                                <optgroup label="Popular Currencies">
                                    {priorityCountries.map(country => (
                                        <option key={country.id} value={country.id}>
                                            {country.currency || country.currency_code} - {country.name}
                                        </option>
                                    ))}
                                </optgroup>
                            )}

                            {/* Other Currencies Group */}
                            {otherCountries.length > 0 && (
                                <optgroup label="Other Currencies">
                                    {otherCountries.map(country => (
                                        <option key={country.id} value={country.id}>
                                            {country.currency || country.currency_code} - {country.name}
                                        </option>
                                    ))}
                                </optgroup>
                            )}

                            {/* No results message */}
                            {priorityCountries.length === 0 && otherCountries.length === 0 && (
                                <option disabled>No currencies found</option>
                            )}
                        </Form.Select>
                        {errors.base_currency_id && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.base_currency_id}</div>}

                    </Form.Group>

                    {/* Exchange Rates Section */}
                    <div className="mb-4">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <Form.Label className='form-font mb-0'>Exchange Rates</Form.Label>
                            <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={addExchangeRate}
                                disabled={!formData.base_currency_id || getAvailableCurrencies().length === 0}
                            >
                                <FaPlus /> Add Rate
                            </Button>
                        </div>



                        {formData.exchange_rates.map((rate, index) => (
                            <div key={index} className="border p-3 mb-3 rounded">
                                <Row className="g-2">
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label className="small">Currency</Form.Label>
                                            <ExchangeRateCurrencyDropdown
                                                index={index}
                                                value={rate.currency_id}
                                                onChange={(currencyId) => handleExchangeRateChange(index, 'currency_id', currencyId)}
                                                error={errors[`exchange_rate_currency_${index}`]}
                                            />
                                            {errors[`exchange_rate_currency_${index}`] && (
                                                <div className="invalid-feedback d-block" style={{ fontSize: '10px' }}>
                                                    {errors[`exchange_rate_currency_${index}`]}
                                                </div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={5}>
                                        <Form.Group>
                                            <Form.Label className="small">Rate</Form.Label>
                                            <Form.Control
                                                type="number"
                                                step="0.000001"
                                                value={rate.rate}
                                                onChange={(e) => handleExchangeRateChange(index, 'rate', e.target.value)}
                                                className={`form-control-sm ${errors[`exchange_rate_rate_${index}`] ? 'is-invalid' : ''}`}
                                                placeholder="e.g., 3.6725"
                                                size="sm"
                                            />
                                            {errors[`exchange_rate_rate_${index}`] && (
                                                <div className="invalid-feedback d-block" style={{ fontSize: '10px' }}>
                                                    {errors[`exchange_rate_rate_${index}`]}
                                                </div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={1} className="d-flex align-items-end">
                                        <Button
                                            variant="outline-danger"
                                            size="sm"
                                            onClick={() => removeExchangeRate(index)}
                                            className="px-2"
                                        >
                                            <FaTrash />
                                        </Button>
                                    </Col>
                                </Row>
                                {rate.currency_id && rate.rate && (
                                    <div className="small text-muted mt-2">
                                        <strong>Rate:</strong> 1 {getCurrencyName(rate.currency_id)} = {parseFloat(rate.rate).toFixed(6)} {getCurrencyName(formData.base_currency_id)}
                                    </div>
                                )}
                            </div>
                        ))}

                        {formData.exchange_rates.length === 0 && (
                            <div className="text-center text-muted py-4 border rounded bg-light">
                                <p className="mb-1">No exchange rates added yet</p>
                                <p className="small mb-0">Add exchange rates to convert between currencies</p>
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={addExchangeRate}
                                    disabled={!formData.base_currency_id}
                                    className="mt-2"
                                >
                                    <FaPlus /> Add First Rate
                                </Button>
                            </div>
                        )}

                        {formData.base_currency_id && getAvailableCurrencies().length === 0 && formData.exchange_rates.length === 0 && (
                            <div className="alert alert-info small py-2">
                                All available currencies have been added as exchange rates.
                            </div>
                        )}
                    </div>

                </Form>
            </Offcanvas.Body>

            {/* Footer with buttons */}
            <div className="p-3 border-top d-flex justify-content-end">
                <button type="button" className="btn btn-secondary me-2" onClick={handleClose}>
                    Cancel
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSubmit} disabled={loading}>
                    {loading ? (
                        <>
                            <Spinner animation="border" size="sm" className="me-2" />
                            Saving...
                        </>
                    ) : (
                        bankId ? 'Update Account' : 'Create Account'
                    )}
                </button>
            </div>
        </Offcanvas>
    );
};

export default BankForm;